<template>
  <div class="position-relative">
    <div class="row no-gutters mb-2">
      <div class="col-7 col-lg-8 pr-1">
        <input type="date" id="pesquisarData" class="form-control" placeholder="Pesquisar pedido" :disabled="load"
               v-model="pesquisa.data" v-if="pesquisa.filtro === '2'" @change="pesquisar" @focus="aberto = false">
        <input id="pesquisarPedido" class="form-control" type="search"
               :placeholder="pesquisa.filtro === '1' ? 'Buscar pedido' : filtros.find(f => f.value === pesquisa.filtro).nome"
               @focus="aberto = false" :disabled="load"
               v-model="pesquisa.data" @search="pesquisarTermo" v-else>
      </div>
      <div class="col-5 col-lg-4">
        <button class="btn btn-block text-nowrap" :class="pesquisa.ativada ? 'btn-success' : 'btn-dark'" @click="togglePesquisa" :disabled="load">
          <i class="fa fa-bars mr-1"></i>
          <small>{{pesquisa.ativada ? 'Filtro ativado' : 'Filtrar'}}</small>
        </button>
      </div>
    </div>
    <div id="campoPesquisar" class="pesquisar" v-if="aberto" tabindex="0" @blur="fechar">
      <div class="card border shadow">
        <div class="mb-3">
          <button class="btn btn-secondary btn-block btn-sm" @click="limparPesquisa()">Limpar pesquisa</button>
        </div>
        <div>
          <h6 class="font-weight-bold mb-1">Status do Pedido</h6>
          <div v-for="f in listStatus">
            <label><input type="radio" name="status" :value="f.value" v-model="pesquisa.status" @change="filtrarStatus">
              {{ f.nome }}
            </label>
          </div>
        </div>
        <hr>
        <div>
          <h6 class="font-weight-bold mb-1">Tipo do Pedido</h6>
          <div v-for="(f, index) in origins" :key="index">
            <label><input type="radio" name="origins" :value="f.value" v-model="pesquisa.origin" @change="filtrarOrigin">
              {{ f.nome }}
            </label>
          </div>
        </div>
        <hr>
        <div>
          <h6 class="font-weight-bold mb-1">Filtrar Pedido</h6>
          <div v-for="f in filtros">
            <label><input type="radio" name="filtros" :value="f.value" v-model="pesquisa.filtro" @change="filtrarTipo">
              {{ f.nome }}
            </label>
          </div>
          <div class="small mt-2">
            * Filtrar pedidos realizados nas últimas 32 horas
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['load'],
  name: "PesquisarPedido",
  data() {
    return {
      filtros: [
        { value: '1', nome: 'Nome ou número' },
        { value: '2', nome: 'Data do pedido' },
        { value: '3', nome: 'Endereço do cliente' }
      ],
      listStatus: [
        { value: '', nome: 'Em andamento' },
        { value: '4', nome: 'Finalizados' },
        { value: '5', nome: 'Cancelados' }
      ],
      origins: [
        { value: '', nome: 'Todos' },
        { value: '1', nome: 'App/Site' },
        { value: '3', nome: 'Pedido Manual' },
        { value: '4', nome: 'QR Code' },
        { value: '5', nome: 'WhatsApp' },
        { value: '8', nome: 'Tablet' }
      ],

      pesquisa: {
        page: 0,
        data: '',
        origin: '',
        status: '',
        filtro: '1',
        ativada: false
      },

      aberto: false
    }
  },

  methods: {
    togglePesquisa() {
      this.aberto = !this.aberto;
      this.$nextTick(() => {
        if (this.aberto) {
          this.$helpers.focusElement('campoPesquisar');
        }
      })
    },

    fechar() {
      setTimeout(() => {
        this.aberto = false;
      }, 600);
    },

    pesquisar() {
      this.aberto = false;
      this.pesquisa.ativada = this.pesquisa.status || this.pesquisa.origin !== '' || !!this.pesquisa.data;
      this.$emit('pesquisar', this.pesquisa);
      this.verificarPiloto();
    },

    pesquisarTermo() {
      if (this.load) {
        return;
      }

      if (!this.pesquisa.data.trim()) {
        this.limparPesquisa();

      } else {
        this.pesquisar();
      }
    },

    filtrarTipo() {
      this.$nextTick(() => {
        this.pesquisa.data = '';
        this.$helpers.focusElement(this.pesquisa.filtro === '2' ? 'pesquisarData' : 'pesquisarPedido');

        if (this.pesquisa.filtro === '2') {
          this.pesquisa.status = '4';
          this.pesquisa.origin = '';
          this.pesquisa.data = new Date().toDateInputValue();
          this.pesquisar();
        }
      });
    },

    filtrarOrigin() {
      this.pesquisar();
    },

    filtrarStatus() {
      this.pesquisa.filtro = '1';
      this.pesquisa.data = '';
      this.pesquisar();
    },

    limparPesquisa() {
      this.pesquisa.filtro = '1';
      this.pesquisa.status = '';
      this.pesquisa.origin = '';
      this.pesquisa.data = '';
      this.pesquisar();
    },

    verificarPiloto() {
      if (this.pilotoAutomatico) {
        this.$store.state.pilotoAutomatico = !this.pesquisa.ativada;
      }
    }
  },

  mounted() {
    if (this.integracoes.find(i => i.plataforma === '2')) {
      this.origins.push({ value: '6', nome: 'iFood' });
    }

    if (this.integracoes.find(i => i.plataforma === '4')) {
      this.origins.push({ value: '7', nome: 'UaiRango' });
    }

    if (this.integracoes.find(i => i.plataforma === '18')) {
      this.origins.push({ value: '11', nome: '99Food' });
    }
  },

  created() {
    this.$parent.$on('clearPesquisa', () => {
      this.pesquisa.filtro = '1';
      this.pesquisa.status = '';
      this.pesquisa.origin = '';
      this.pesquisa.data = '';
      this.pesquisa.ativada = false;
      this.verificarPiloto();
    });
  },

  computed: {
    integracoes() {
      return this.$store.state.integracoes
    },

    pilotoAutomatico() {
      return this.$store.state.pilotoAutomatico
    }
  }
}
</script>

<style scoped>
.pesquisar {
  position: absolute;
  top: 42px;
  right: 4px;
  z-index: 99;
}

.pesquisar .card {
  padding: 14px 12px;
  width: 222px;
  height: 322px;
  overflow-y: auto;
}

.pesquisar label {
  cursor: pointer;
  margin: 6px 0 0;
  font-size: 14px;
}

.pesquisar h6 {
  font-size: 15px;
}
</style>
